import { RoomResponseDtoStatusEnum } from '@uniquegood/realworld-play-interface/dist';

export const roomStatusToLabel: Record<RoomResponseDtoStatusEnum, string> = {
  [RoomResponseDtoStatusEnum.Created]: '생성됨',
  [RoomResponseDtoStatusEnum.Waiting]: '대기중',
  [RoomResponseDtoStatusEnum.Playing]: '진행중',
  [RoomResponseDtoStatusEnum.Closed]: '종료룸',
};
